// Gatsby requirements
import React, { useState, useEffect } from "react"
import { Link, useStaticQuery, graphql } from 'gatsby'

// Components
import RichTextRenderer from '../richTextRenderer'
import Button from '../linkLogic'
import Search from "../search"

// Styles
import * as CSS from './header.module.scss'

const Header = ({ en, alternateSlug, previewData }) =>  {

    // Header data query
    const data = useStaticQuery(graphql`
        query {
            header: storyblokEntry(field_component: {eq: "Header"}, slug: {eq: "header"}) {
                content
            }
        }
    `)

    // Header content to parsed JSON
    const jsonData = previewData?.content || JSON.parse(data.header.content)
    // const jsonDataEn = previewData?.content || JSON.parse(data.header_en.content)

    // Logic for opening the mobile header navigation
    const [isMenuOpen, setMenuOpen] = useState(false)
    // const [isLanguageOpen, setLanguageOpen] = useState(false)

    // Algolia search
    const searchIndices = [{ name: `Pages`, title: `Pages` }]

    // Add sublist icons
    useEffect(() => {
        var nums = document.getElementById("navigation");
        var listItem = nums.getElementsByTagName("li");
        for (let item of listItem) {
            if (item.childElementCount > 1) {
                item.classList.add("has-sublist");
            }
        }
    }, [])
    
    return(
        <header id="top" className={`${CSS.header} ${isMenuOpen === true ? CSS.active: ''}`}>
            
            <div className={CSS.topHeader}>
                <div className="wrapper">

                    <a className={CSS.skip} href="#content">Skip to content</a>
                    
                    <Link style={{marginBottom: `${jsonData?.site_logo_bottom_margin}px`}} to={en === true ? '/en/' : '/'}>
                        <img 
                            style={{
                                height: `${jsonData?.site_logo_height}px`
                            }}
                            src={jsonData?.site_logo?.filename}
                            width={jsonData.site_logo?.filename?.split('/')[5]?.split('x')[0]}
                            height={jsonData?.site_logo?.filename?.split('/')[5]?.split('x')[1]}
                            alt={jsonData?.site_logo?.alt} 
                        />
                    </Link>
                    
                    <div className={CSS.cta}>
                        {/* <div className={`${CSS.language} ${isLanguageOpen === true ? CSS.activeLanguage : ''}`}>
                            <button
                                aria-expanded={isLanguageOpen === false ? 'false' : 'true'}
                                onClick={() => isLanguageOpen === true ? setLanguageOpen(false) : setLanguageOpen(true) }
                                className={CSS.languagePopUp}
                                aria-haspopup="true" 
                                aria-controls="language-menu"
                            >
                                {en === true ? 'EN' : 'NL'}
                            </button>
                            {alternateSlug && alternateSlug !== '/undefined' ?
                                <Link id="language-menu" to={alternateSlug}>{en === true ? 'NL' : 'EN'}</Link>
                                :
                                <Link id="language-menu" to={en === true ? '/' : '/en/'}>{en === true ? 'NL' : 'EN'}</Link>
                            }
                        </div> */}
                        
                        {process.env.GATSBY_ALGOLIA_APP_ID && process.env.GATSBY_ALGOLIA_APP_ID !== "false" &&
                            <Search indices={searchIndices} en={true} />
                        }

                        {jsonData?.cta_button?.map(loop => (
                            <Button data={loop} />
                        ))}
                    </div>

                    <button
                        aria-haspopup="true"
                        aria-label="Open main menu"
                        aria-expanded={isMenuOpen === true ? "true" : "false"}
                        onClick={() =>
                            isMenuOpen === true
                                ? setMenuOpen(false)
                                : setMenuOpen(true)
                        }
                    >
                        <svg viewBox="0 0 100 80" fill="#154273" width="30" height="30">
                            <rect width="100" height="11"></rect>
                            <rect y="30" width="80" height="11"></rect>
                            <rect y="60" width="60" height="11"></rect>
                        </svg>
                    </button>
                </div>
            </div>

            <div className={CSS.bottomHeader}>
                <div className="wrapper">
                    {process.env.GATSBY_ALGOLIA_APP_ID && process.env.GATSBY_ALGOLIA_APP_ID !== "false" &&
                        <div className={CSS.mobileSearch}>
                            <Search indices={searchIndices} en={true} />
                        </div>
                    }
                    <nav id="navigation">
                        <RichTextRenderer data={jsonData?.header_links} />
                    </nav>
                    <div className={CSS.ctaMobile}>
                        {jsonData?.cta_button?.map(loop => (
                            <Button data={loop} />
                        ))}
                    </div>
                </div>
            </div>

        </header>
    )
}

export default Header